import React from "react";
import styled from "styled-components";

// Dummy image links
const dummyImages = [
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1738820328/hikvision_zs0vhz.png",
  "https://www.dlink.com/in/en/-/media/logos/dlink/logoblue.svg",
  "images/aeconnect.png",
  "https://www.honeywell.com/content/dam/honeywellbt/en/images/logos/HON%20logo_200x37%202.png",
  "https://realtimebiometrics.com/img/logo/logo-black.png",
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1737457970/svgviewer-output_onqs23.svg",
  "https://www.nexttechgroup.com/nextview/public/Profile-PIC.png",
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1738820328/unv_u8hxgc.png",
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1738820328/hi-focus_irap1u.png",
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1738820328/Netgear_exstaq.png",
  "https://res.cloudinary.com/ddffnw81j/image/upload/v1738820328/dhuva_zmtycz.jpg",
  "images/ajax.png",
  "images/ravel.png",
  "images/securio.png",
  "images/zk.png",

];

const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 30px;
  padding: 0 10px;
`;

const ClientCard = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
  }
`;

const ClientImage = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 15px;
`;

const AuthorizedDistributors = () => {
  return (
    <section className="bleezy-service-area">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="heading_container" style={{ marginBottom: "30px" }}>
              <h2 className="section-title">
                Authorised Partners
                <br />
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <ClientsGrid>
          {dummyImages.map((image, index) => (
            <ClientCard key={index}>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <ClientImage src={image} alt={`Client ${index + 1}`} />
              </a>
            </ClientCard>
          ))}
        </ClientsGrid>
      </div>
    </section>
  );
};

export default AuthorizedDistributors;
